// extracted by mini-css-extract-plugin
export default {"footer":"ProfileDetails_footer__57bYh"};